module.exports = __webpack_public_path__ + "img/14.89be798a.svg";